<script lang="ts">
const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_file_size.name',
	description: '$t:blocks.display_file_size.description',
	category: 'display',
	hidden: true,
}
</script>
<script lang="ts" setup>
import type { DisplayBlockProps } from '#layers/blocks/types/display-block';
import type { InputBlockProps } from '#layers/blocks/types/input-block';
import { computed } from 'vue';

import { formatFilesize } from '#layers/assets/public';
import { defineBlock } from '#layers/block-engine/public';
import { usePrimitiveFormField } from '#layers/forms/public';

interface Props extends InputBlockProps, DisplayBlockProps<number> {}

const props = defineProps<Props>();

const model = defineModel<number>();

;

const { modelValue } = usePrimitiveFormField({}, { model });

const displayValue = computed(() => modelValue.value ?? props.value);
</script>

<template>
	<div class="text-sm">
		{{ formatFilesize(displayValue) }}
	</div>
</template>
